var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingList.newBillingDialog")) + " ")]), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-2"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('components.thg.thgBillingList.billingNumber'),
      "outlined": "",
      "value": _vm.billingNumber + 1,
      "disabled": "",
      "rounded": ""
    }
  })], 1), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-n4"
  }, [_c('thg-billing-creditor-selection-user-list', {
    attrs: {
      "userId": _vm.newBilling.userId
    },
    on: {
      "update:userId": function updateUserId($event) {
        return _vm.$set(_vm.newBilling, "userId", $event);
      },
      "update:user-id": function updateUserId($event) {
        return _vm.$set(_vm.newBilling, "userId", $event);
      }
    }
  })], 1), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-n4"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('components.thg.thgBillingList.accountNumber'),
      "outlined": "",
      "rounded": ""
    },
    model: {
      value: _vm.newBilling.accountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.newBilling, "accountNumber", $$v);
      },
      expression: "newBilling.accountNumber"
    }
  })], 1), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-n4"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.thg.thgBillingList.thgId'),
      "outlined": "",
      "rounded": ""
    },
    model: {
      value: _vm.newBilling.thgId,
      callback: function callback($$v) {
        _vm.$set(_vm.newBilling, "thgId", $$v);
      },
      expression: "newBilling.thgId"
    }
  })], 1), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-n4"
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('components.thg.thgBillingList.partnerId'),
      "outlined": "",
      "rounded": ""
    },
    model: {
      value: _vm.newBilling.partnerId,
      callback: function callback($$v) {
        _vm.$set(_vm.newBilling, "partnerId", $$v);
      },
      expression: "newBilling.partnerId"
    }
  })], 1), _c('v-row', {
    staticClass: "ml-5 mr-5 mt-n4"
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.typeLabels,
      "type": "string",
      "label": _vm.$t('components.thg.thgBillingList.type'),
      "outlined": "",
      "rounded": ""
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  })], 1), _c('v-spacer'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "loading": _vm.loadingCreateBilling
    },
    on: {
      "click": _vm.createNewBilling
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.thgBillingList.createNewBilling")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }